/* @flow */
// $FlowIgnore
import _ from 'lodash';
import history from '../history';
import { useNavigate } from 'react-router';
import { stringify } from 'qs';

export type PaginationParams = {
  first: number,
  offset: number,
  sort: string,
  order: string
}

export const parseActiveProject = ({
  params: {
    program,
    project,
  },
}: Object): ?string => project`${program}-${project}`;

export const parseQueryParams = ({
  location: {
    query: {
      first,
      offset,
      order,
      sort,
      ...rest
    },
  },
}: Object): Object => rest;

export function parsePaginationParams({
  location: {
    query: {
      first,
      offset,
      order,
      sort,
      sort_by,
    },
  },
}: Object, {
  path,
  ...defaults
}: Object = {}): PaginationParams {
  const [sort_by__sort, sort_by__order] = (sort_by || '').split(':');
  return {
    first: first
      ? parseInt(first, 10)
      : (defaults || {}).first || 20,
    offset: offset
      ? parseInt(offset, 10)
      : (defaults || {}).first || 0,
    order: (sort_by && sort_by__order)
      || order
      || (defaults || {}).order
      || 'desc',
    sort: (sort_by && sort_by__sort)
      || sort
      || (defaults || {}).sort
      || (path === 'qc' && 'severity')
      || 'updated_datetime',
    sort_by: sort_by
      || (defaults || {}).sort_by
      || 'severity:desc',
  };
}

export const hasPaginationChanged = (
  router1: Object,
  router2: Object,
): bool => {
  const params1 = parsePaginationParams(router1);
  const params2 = parsePaginationParams(router2);

  return !(
    params1.first === params2.first
    && params1.offset === params2.offset
    && params1.sort === params2.sort
    && params1.order === params2.order
  );
};

export const queryHasChanged = (
  prevQuery: Object,
  nextQuery: Object,
): bool => !_.isEqual(prevQuery, nextQuery);


export const shouldListRefresh = (
  { did: prevDid, ...prevRest }: Object,
  { did: nextDid, ...nextRest }: Object,
): bool => !_.isEqual(prevRest, nextRest);

export const useUpdateQueryParams = () => {
  const navigate = useNavigate();

  return (
  {
    router: {
      location: {
        pathname,
        query: currentQuery,
      },
    },
  }: Object,
  newQuery: Object,
): void => {
  navigate({ pathname, search: `?${stringify({ ...currentQuery, ...newQuery })}`});
};
};

export const replaceQueryParams = (
  { router: { location: { pathname } } }: Object,
  newQuery: Object,
): void => {
  history.pushState(null, pathname, newQuery);
};
